import { FC, ReactNode } from 'react';
import styles from './PageWrapper.module.css';

interface PageWrapperProps {
  children: ReactNode
}

const PageWrapper: FC<PageWrapperProps> = ({ children }) => (
  <div className={styles.PageWrapper}>
    {children}
  </div>
);

export default PageWrapper;
